import React from 'react'
import { TextField, VariantType } from '@entur/form'
import { ValidationFormField, validateFormField } from '../../utils/form-utils'

type ValidatableTextFieldProps = {
  field: ValidationFormField<string>
  update: (value: ValidationFormField<string>) => void
  onBlur?: () => void
  disabled?: boolean
}
export const ValidatableTextField: React.FC<ValidatableTextFieldProps> = (props) => {
  const validateAndUpdate = () => {
    const validatedFormField = validateFormField(props.field) as ValidationFormField<string>
    props.update(validatedFormField)
    if (validatedFormField.variant !== 'error') {
      props.onBlur?.()
    }
  }

  return (
    <TextField
      name={props.field.fieldName}
      label={props.field.displayName}
      variant={props.field.variant as VariantType}
      feedback={props.field.feedback}
      labelTooltip={props.field.tooltip}
      placeholder={props.field.placeholder}
      value={props.field.value}
      onChange={(e: { target: { value: string } }) => props.update({ ...props.field, value: e.target.value })}
      onBlur={validateAndUpdate}
      disabled={props.disabled}
    />
  )
}
